import paymentmethods from './PaymentMethods/PaymentMethods';
import dynamicpaymentmethods from './DynamicPaymentMethods/DynamicPaymentMethods';
import frequencyamounts from './FrequencyAmounts/FrequencyAmounts';
import zipcodepostcodeapi from './ZipcodePostcodeAPI/ZipcodePostcodeAPI';
import housenumberadditionpostcodeapi from './HouseNumberAdditionPostcodeAPI/HouseNumberAdditionPostcodeAPI';
import products from './Products/Products';
import rowgrid from './RowGrid/RowGrid';
export default {
    paymentmethods: paymentmethods,
    dynamicpaymentmethods: dynamicpaymentmethods,
    frequencyamounts: frequencyamounts,
    zipcodepostcodeapi: zipcodepostcodeapi,
    housenumberadditionpostcodeapi: housenumberadditionpostcodeapi,
    products: products,
    rowgrid: rowgrid
};
